export default __webpack_public_path__ + "62fa2ec8b71c0b952500af6914b30bbd.wav";